import React, { Component } from 'react'
import { Input, Label, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import DropzoneComponent from 'react-dropzone-component'
import { BlockWithLoader } from '../../Support'
import { RiseLoader } from 'react-spinners'
import { API_BASE_URL } from '../../../utils/apiConfig'
import { UploadFiles, acceptedFiles, acceptedFilesIcons } from '../../../utils/uploadFiles'
import InspectionLogModal from '../../EventLog/InspectionLogModal'
import ConfirmModal from '../../Alerts/ConfirmModal'
import { destroyLogMutation } from '../../Logs/mutations'
import { LogsListQuery } from '../../Logs/mutations'
import CreatableSelect from '../../Wps/CreatableSelect'
import { getUserPermissions } from '../../../utils/userPermissions'

const ASSIGN_REPORT_NO_MUTATION = gql`
  mutation assignReportNo($log_ids: [ID!]!, $report_no: String, $clear_attachments: Boolean) {
    assignReportNo(log_ids: $log_ids, report_no: $report_no, clear_attachments: $clear_attachments) {
      response
    }
  }
`

const NDT_LOGS_QUERY = gql`
  query NdtLogsQuery($project_id: ID!, $include_project_descendants_welds: Boolean, $page: Int, $size: Int, $filters: NdtLogFilterInput) {
    ndt_logs(project_id: $project_id, include_project_descendants_welds: $include_project_descendants_welds, page: $page, size: $size, filters: $filters) {
      list {
        id
        date
        complete
        complete_percent
        log_data
        note
        weld_failed
        double_length
        gauging
        skipped
        weld_inspection_group_id
        inspection_category_type {
          id
          name
        }
        person {
          id
          name
          first_name
          last_name
        }
        weld {
          id
          no
        }
        attachments {
          id
          data_file_name
          url
        }
      }
    }
    inspection_log_data_types {
      id
      name
    }
    inspection_category_types {
      id
      name
    }
    people(filters: { permission_key: "core.people.inspector", active: "true" }) {
      list {
        id
        name
      }
    }
  }
`

class NdtTab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      logs: [],
      includeDescendants: false,
      loading: false,
      selectedLogs: [],
      reportNoKeyId: null,
      inspCatTypesDict: [],
      peopleList: [],
      // edit/delete
      logEditData: null,
      editWeldData: null,
      logIdRemove: null,
      // expand
      expandedLogs: [],
      expandAll: false,
      // assign modal
      assignModalOpen: false,
      reportNoValue: '',
      assignFiles: [],
      // bulk delete
      deleteConfirmOpen: false,
      // filters
      filters: {
        weld_no: '',
        inspection_category_type_id: '',
        person_id: '',
        date_from: '',
        date_to: '',
        complete_from: '',
        complete_to: '',
        complete_percent_from: '',
        complete_percent_to: '',
        report_no: '',
        weld_failed: '',
        gauging: '',
        has_attachments: ''
      }
    }
  }

  componentDidMount() {
    this.readFiltersFromUrl(() => this.loadLogs())
  }

  readFiltersFromUrl(cb) {
    const params = new URLSearchParams(this.props.location.search)
    const filters = { ...this.state.filters }
    Object.keys(filters).forEach(key => {
      const val = params.get(key)
      if (val) filters[key] = val
    })
    this.setState({ filters, includeDescendants: params.get('descendants') === 'true' }, cb)
  }

  writeFiltersToUrl() {
    const params = new URLSearchParams(this.props.location.search)
    const f = this.state.filters
    Object.keys(f).forEach(key => {
      if (f[key]) { params.set(key, f[key]) } else { params.delete(key) }
    })
    if (this.state.includeDescendants) { params.set('descendants', 'true') } else { params.delete('descendants') }
    this.props.history.replace({ search: params.toString() })
  }

  loadLogs() {
    this.setState({ loading: true })
    const filters = {}
    const f = this.state.filters
    if (f.weld_no) {
      if (f.weld_no === '__') { filters.weld_no_empty = true } else { filters.weld_no = f.weld_no }
    }
    if (f.inspection_category_type_id) filters.inspection_category_type_id = [f.inspection_category_type_id]
    if (f.person_id) filters.person_id = [f.person_id]
    if (f.date_from) filters.date_from = f.date_from
    if (f.date_to) filters.date_to = f.date_to
    if (f.complete_from) filters.complete_from = Number(f.complete_from)
    if (f.complete_to) filters.complete_to = Number(f.complete_to)
    if (f.complete_percent_from) filters.complete_percent_from = Number(f.complete_percent_from)
    if (f.complete_percent_to) filters.complete_percent_to = Number(f.complete_percent_to)
    if (f.report_no) {
      if (f.report_no === '__') { filters.report_no_empty = true } else { filters.report_no = f.report_no }
    }
    if (f.has_attachments === 'true') filters.has_attachments = true
    if (f.has_attachments === 'false') filters.has_attachments = false
    if (f.weld_failed) filters.weld_failed = f.weld_failed
    if (f.gauging === 'true') filters.gauging = true
    if (f.gauging === 'false') filters.gauging = false

    this.props.client.query({
      query: NDT_LOGS_QUERY,
      variables: {
        project_id: this.props.parentId,
        include_project_descendants_welds: this.state.includeDescendants,
        filters: Object.keys(filters).length > 0 ? filters : undefined,
        page: 1,
        size: 10000
      },
      fetchPolicy: 'network-only'
    }).then(({ data }) => {
      const reportNoType = data.inspection_log_data_types && data.inspection_log_data_types.find(t => t.name === 'REPORT_NO')
      this.setState({
        logs: data.ndt_logs ? data.ndt_logs.list : [],
        loading: false,
        reportNoKeyId: reportNoType ? reportNoType.id : null,
        inspCatTypesDict: data.inspection_category_types || [],
        peopleList: data.people ? data.people.list : []
      })
    }).catch(() => {
      this.setState({ loading: false })
    })
  }

  getReportNo(log) {
    if (!this.state.reportNoKeyId || !log.log_data) return null
    try {
      const data = typeof log.log_data === 'string' ? JSON.parse(log.log_data) : log.log_data
      return data[this.state.reportNoKeyId] || null
    } catch (e) {
      return null
    }
  }

  toggleLog = (logId) => {
    this.setState(prev => ({
      selectedLogs: prev.selectedLogs.includes(logId)
        ? prev.selectedLogs.filter(id => id !== logId)
        : [...prev.selectedLogs, logId]
    }))
  }

  toggleExpand = (logId) => {
    this.setState(prev => ({
      expandedLogs: prev.expandedLogs.includes(logId)
        ? prev.expandedLogs.filter(id => id !== logId)
        : [...prev.expandedLogs, logId]
    }))
  }

  handleFilterChange = (key, value) => {
    this.setState(prev => ({ filters: { ...prev.filters, [key]: value } }))
  }

  applyFilters = () => {
    this.writeFiltersToUrl()
    this.loadLogs()
  }

  clearFilters = () => {
    this.setState({
      filters: {
        weld_no: '',
        inspection_category_type_id: '',
        person_id: '',
        date_from: '',
        date_to: '',
        complete_from: '',
        complete_to: '',
        complete_percent_from: '',
        complete_percent_to: '',
        report_no: '',
        weld_failed: '',
        gauging: '',
        has_attachments: ''
      }
    }, () => {
      this.writeFiltersToUrl()
      this.loadLogs()
    })
  }

  groupLogsByWeld() {
    const grouped = {}
    this.state.logs.forEach(log => {
      if (!log.weld) return
      const key = log.weld.id
      if (!grouped[key]) grouped[key] = { weld: log.weld, logs: [] }
      grouped[key].logs.push(log)
    })
    return Object.values(grouped)
  }

  handleEdit = (log, e) => {
    e.stopPropagation()
    // Fetch full weld data for the modal
    this.props.client.query({
      query: LogsListQuery,
      variables: { weld_id: log.weld.id },
      fetchPolicy: 'network-only'
    }).then(({ data }) => {
      this.setState({
        logEditData: data.weld.logs.find(l => l.id === log.id) || log,
        editWeldData: data.weld
      })
    })
  }

  handleDelete = (logId, e) => {
    e.stopPropagation()
    this.setState({ logIdRemove: logId })
  }

  runRemoveLog = () => {
    this.props.client.mutate({
      mutation: destroyLogMutation,
      variables: { id: this.state.logIdRemove }
    }).then(() => {
      this.setState({ logIdRemove: null })
      this.loadLogs()
    })
  }

  runBulkDelete = () => {
    Promise.all(this.state.selectedLogs.map(id =>
      this.props.client.mutate({ mutation: destroyLogMutation, variables: { id } })
    )).then(() => {
      this.setState({ deleteConfirmOpen: false, selectedLogs: [] })
      this.loadLogs()
    })
  }

  closeEditModal = () => {
    this.setState({ logEditData: null, editWeldData: null })
  }

  afterEditSubmit = () => {
    this.closeEditModal()
    this.loadLogs()
  }

  submitAssign = () => {
    const { selectedLogs, reportNoValue, assignFiles } = this.state
    if (!reportNoValue && assignFiles.length === 0) return

    const done = () => {
      this.setState({ assignModalOpen: false, reportNoValue: '', assignFiles: [] })
      this.loadLogs()
    }

    const variables = { log_ids: selectedLogs }
    if (reportNoValue) variables.report_no = reportNoValue
    if (assignFiles.length > 0) variables.clear_attachments = true

    this.props.client.mutate({
      mutation: ASSIGN_REPORT_NO_MUTATION,
      variables
    }).then(() => {
      if (assignFiles.length > 0) {
        UploadFiles(selectedLogs, 'WlWelds::Log', assignFiles).then(done)
      } else {
        done()
      }
    })
  }

  render() {
    const { loading, selectedLogs } = this.state
    const groupedWelds = this.groupLogsByWeld()

    if (loading) {
      return <div style={{ textAlign: 'center', padding: '40px' }}><RiseLoader color="#20a8d8" loading={true} /></div>
    }

    return (
      <div style={{ padding: '15px 0' }}>
        <ConfirmModal
          isOpened={!!this.state.logIdRemove}
          onCancel={() => this.setState({ logIdRemove: null })}
          onConfirm={this.runRemoveLog}
          headerText='Remove Log'
          bodyText='Are you sure you want to delete this log?'
          confirmBtnText='Remove'
        />

        <ConfirmModal
          isOpened={this.state.deleteConfirmOpen}
          onCancel={() => this.setState({ deleteConfirmOpen: false })}
          onConfirm={this.runBulkDelete}
          headerText='Delete inspections'
          bodyText={`Are you sure you want to delete ${this.state.selectedLogs.length} inspection(s)?`}
          confirmBtnText='Delete'
        />

        <Modal isOpen={this.state.assignModalOpen}>
          <ModalHeader>Assign to selected logs</ModalHeader>
          <ModalBody>
            <Label>Report No</Label>
            <Input type="text" value={this.state.reportNoValue}
              onChange={e => this.setState({ reportNoValue: e.target.value })} />
            <br />
            <Label>Attachment</Label>
            <DropzoneComponent
              config={{ iconFiletypes: acceptedFilesIcons, showFiletypeIcon: true, postUrl: 'no-url' }}
              eventHandlers={{
                addedfile: (file) => this.setState(prev => ({ assignFiles: [...prev.assignFiles, file] })),
                removedfile: (file) => this.setState(prev => ({ assignFiles: prev.assignFiles.filter(f => f !== file) }))
              }}
              djsConfig={{ addRemoveLinks: true, autoProcessQueue: false, acceptedFiles, maxFiles: 1 }}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.submitAssign}
              disabled={!this.state.reportNoValue && this.state.assignFiles.length === 0}>Save</Button>
            <Button color="secondary" onClick={() => this.setState({ assignModalOpen: false, reportNoValue: '', assignFiles: [] })}>Cancel</Button>
          </ModalFooter>
        </Modal>

        {this.state.editWeldData && this.state.editWeldData.inspection_category &&
          <InspectionLogModal
            isOpened={true}
            onCancel={this.closeEditModal}
            afterSubmit={this.afterEditSubmit}
            weldsData={[this.state.editWeldData]}
            weldInspCat={this.state.editWeldData.inspection_category}
            inspCatTypesDict={this.state.inspCatTypesDict}
            editData={this.state.logEditData}
            LogModalWeldInspId={this.state.logEditData && Number(this.state.logEditData.inspection_category_type.id)}
          />}

        <div style={{ border: '1px solid #e4e7ea', borderRadius: '4px', padding: '10px', marginBottom: '10px' }}>
          <Row>
            <Col md="2">
              <Label style={{ fontSize: '0.8em' }}>Weld No</Label>
              <Input type="text" bsSize="sm" placeholder="exact (or %like%), __ for empty" value={this.state.filters.weld_no}
                onChange={e => this.handleFilterChange('weld_no', e.target.value)} />
            </Col>
            <Col md="3">
              <Label style={{ fontSize: '0.8em' }}>Inspection type</Label>
              <CreatableSelect
                options={this.state.inspCatTypesDict}
                valueKey="id"
                labelKey="name"
                value={this.state.filters.inspection_category_type_id || null}
                multi={false}
                creatable={false}
                placeholder="All"
                valueChangeFunction={(val) => this.handleFilterChange('inspection_category_type_id', val ? val.id : '')}
              />
            </Col>
            <Col md="3">
              <Label style={{ fontSize: '0.8em' }}>Inspector</Label>
              <CreatableSelect
                options={this.state.peopleList}
                valueKey="id"
                labelKey="name"
                value={this.state.filters.person_id || null}
                multi={false}
                creatable={false}
                placeholder="All"
                valueChangeFunction={(val) => this.handleFilterChange('person_id', val ? val.id : '')}
              />
            </Col>
            <Col md="2">
              <Label style={{ fontSize: '0.8em' }}>Date from</Label>
              <Input type="date" bsSize="sm" value={this.state.filters.date_from}
                onChange={e => this.handleFilterChange('date_from', e.target.value)} />
            </Col>
            <Col md="2">
              <Label style={{ fontSize: '0.8em' }}>Date to</Label>
              <Input type="date" bsSize="sm" value={this.state.filters.date_to}
                onChange={e => this.handleFilterChange('date_to', e.target.value)} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md="2">
              <Label style={{ fontSize: '0.8em' }}>mm from / to</Label>
              <div style={{ display: 'flex', gap: '4px' }}>
                <Input type="number" bsSize="sm" placeholder="from" value={this.state.filters.complete_from}
                  onChange={e => this.handleFilterChange('complete_from', e.target.value)} />
                <Input type="number" bsSize="sm" placeholder="to" value={this.state.filters.complete_to}
                  onChange={e => this.handleFilterChange('complete_to', e.target.value)} />
              </div>
            </Col>
            <Col md="2">
              <Label style={{ fontSize: '0.8em' }}>% from / to</Label>
              <div style={{ display: 'flex', gap: '4px' }}>
                <Input type="number" bsSize="sm" placeholder="from" value={this.state.filters.complete_percent_from}
                  onChange={e => this.handleFilterChange('complete_percent_from', e.target.value)} />
                <Input type="number" bsSize="sm" placeholder="to" value={this.state.filters.complete_percent_to}
                  onChange={e => this.handleFilterChange('complete_percent_to', e.target.value)} />
              </div>
            </Col>
            <Col md="2">
              <Label style={{ fontSize: '0.8em' }}>Report No</Label>
              <Input type="text" bsSize="sm" placeholder="exact (or %like%), __ for empty" value={this.state.filters.report_no}
                onChange={e => this.handleFilterChange('report_no', e.target.value)} />
            </Col>
            <Col md="1">
              <Label style={{ fontSize: '0.8em' }}>Result</Label>
              <Input type="select" bsSize="sm" value={this.state.filters.weld_failed}
                onChange={e => this.handleFilterChange('weld_failed', e.target.value)}>
                <option value="">All</option>
                <option value="positive">Positive</option>
                <option value="failed">Failed</option>
              </Input>
            </Col>
            <Col md="1">
              <Label style={{ fontSize: '0.8em' }}>Gauging</Label>
              <Input type="select" bsSize="sm" value={this.state.filters.gauging}
                onChange={e => this.handleFilterChange('gauging', e.target.value)}>
                <option value="">All</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </Input>
            </Col>
            <Col md="2">
              <Label style={{ fontSize: '0.8em' }}>Has attachments</Label>
              <Input type="select" bsSize="sm" value={this.state.filters.has_attachments}
                onChange={e => this.handleFilterChange('has_attachments', e.target.value)}>
                <option value="">All</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </Input>
            </Col>
            <Col md="2" style={{ display: 'flex', alignItems: 'flex-end', gap: '6px', paddingBottom: '4px' }}>
              <Button size="sm" color="primary" onClick={this.applyFilters}>Filter</Button>
              <Button size="sm" color="secondary" onClick={this.clearFilters}>Clear</Button>
            </Col>
          </Row>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>Show welds from all elements &nbsp;</span>
            <Label className="switch switch-sm switch-text switch-info mb-0">
              <Input type="checkbox" className="switch-input"
                defaultChecked={this.state.includeDescendants}
                onChange={() => {
                  this.setState({ includeDescendants: !this.state.includeDescendants, selectedLogs: [] }, () => {
                    this.writeFiltersToUrl()
                    this.loadLogs()
                  })
                }} />
              <span className="switch-label" data-on="On" data-off="Off" />
              <span className="switch-handle" />
            </Label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>Show details &nbsp;</span>
            <Label className="switch switch-sm switch-text switch-info mb-0">
              <Input type="checkbox" className="switch-input"
                checked={this.state.expandAll}
                onChange={() => this.setState(prev => ({ expandAll: !prev.expandAll }))} />
              <span className="switch-label" data-on="On" data-off="Off" />
              <span className="switch-handle" />
            </Label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>Select all &nbsp;</span>
            <Label className="switch switch-sm switch-text switch-info mb-0">
              <Input type="checkbox" className="switch-input"
                checked={this.state.logs.length > 0 && this.state.selectedLogs.length === this.state.logs.length}
                onChange={() => {
                  this.setState(prev => ({
                    selectedLogs: prev.selectedLogs.length === prev.logs.length ? [] : prev.logs.map(l => l.id)
                  }))
                }} />
              <span className="switch-label" data-on="On" data-off="Off" />
              <span className="switch-handle" />
            </Label>
          </div>
        </div>
        {selectedLogs.length > 0 && (
          <div style={{ background: '#f0f8ff', border: '1px solid #20a8d8', borderRadius: '4px', padding: '8px 12px', marginBottom: '10px' }}>
            <strong style={{ fontSize: '0.85em' }}>Selected ({selectedLogs.length}):</strong>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
              {this.state.logs.filter(l => selectedLogs.includes(l.id)).map(l => (
                <span key={l.id} style={{ background: '#20a8d8', color: '#fff', borderRadius: '3px', padding: '2px 7px', fontSize: '0.8em' }}>
                  {l.weld ? l.weld.no : l.id}{l.inspection_category_type ? ` / ${l.inspection_category_type.name}` : ''}
                </span>
              ))}
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
          {getUserPermissions('wl_welds.inspection_logs.update') &&
            <Button size="sm" color="info" disabled={this.state.selectedLogs.length === 0}
              onClick={() => this.setState({ assignModalOpen: true })}>Assign report no / attachment</Button>}
          {getUserPermissions('wl_welds.inspection_logs.destroy') &&
            <Button size="sm" color="danger" disabled={this.state.selectedLogs.length === 0}
              onClick={() => this.setState({ deleteConfirmOpen: true })}>Delete inspections</Button>}
        </div>
        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <BlockWithLoader loading={loading} renderChildren={true}>
          {groupedWelds.map(({ weld, logs }) => (
            <div key={weld.id} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px', borderBottom: '1px solid #e4e7ea', paddingBottom: '10px' }}>
              <div style={{ minWidth: '80px', paddingTop: '10px' }}>
                <div style={{ fontWeight: 'bold' }}>{weld.no}</div>
                <div style={{ fontSize: '0.8em', color: '#999' }}>{weld.id}</div>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {logs.map(log => {
                  const isSelected = selectedLogs.includes(log.id)
                  const isExpanded = this.state.expandAll || this.state.expandedLogs.includes(log.id)
                  return (
                    <div key={log.id}
                      onClick={() => this.toggleLog(log.id)}
                      onDoubleClick={() => this.toggleExpand(log.id)}
                      style={{
                        border: isSelected ? '2px solid #1a6a9a' : '1px solid #c8ced3',
                        boxShadow: isSelected ? '0 0 0 1px #20a8d8' : 'none',
                        borderRadius: '4px',
                        padding: '8px',
                        minWidth: '120px',
                        cursor: 'pointer',
                        background: log.weld_failed ? '#f8d7da' : log.gauging ? '#e8f4f8' : '#cce5ff',
                        position: 'relative'
                      }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <b>{log.inspection_category_type ? log.inspection_category_type.name : '-'}</b>
                        <span style={{ marginLeft: '8px', whiteSpace: 'nowrap' }}>
                          {getUserPermissions('wl_welds.inspection_logs.update') &&
                            <i className="fa fa-edit" style={{ color: '#ffc107', cursor: 'pointer', marginRight: '6px' }}
                              onClick={(e) => this.handleEdit(log, e)} />}
                          {getUserPermissions('wl_welds.inspection_logs.destroy') &&
                            <i className="fa fa-trash-o" style={{ color: '#f86c6b', cursor: 'pointer' }}
                              onClick={(e) => this.handleDelete(log.id, e)} />}
                        </span>
                      </div>
                      <div style={{ fontSize: '0.85em' }}>
                        {log.complete != null ? `${log.complete} mm` : '-'} / {log.complete_percent != null ? `${log.complete_percent}%` : '-'}
                      </div>
                      {isExpanded && <React.Fragment>
                        <div style={{ fontSize: '0.85em' }}>
                          {log.person ? `${log.person.last_name || ''} ${log.person.first_name || ''}`.trim() : '-'}
                        </div>
                        <div style={{ fontSize: '0.85em' }}>{log.date || '-'}</div>
                        {this.getReportNo(log) && <div style={{ fontSize: '0.85em' }}>{this.getReportNo(log)}</div>}
                        {log.attachments && log.attachments.length > 0 && <div style={{ fontSize: '0.8em' }}>
                          {log.attachments.map(att => (
                            <div key={att.id}><a href={API_BASE_URL + att.url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>{att.data_file_name}</a></div>
                          ))}
                        </div>}
                      </React.Fragment>}
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </BlockWithLoader>
        </div>
      </div>
    )
  }
}

export default withApollo(NdtTab)



// WEBPACK FOOTER //
// ./src/components/Projects/tabs/NdtTab.js